{
  "familyId": "GET-KOMMA-AFRONDEN",
  "questions": [
    {
      "id": "GET-KOMMA-AFRONDEN-001",
      "familyId": "GET-KOMMA-AFRONDEN",
      "module": "Getalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "komma_afronden",
      "questionType": "multiple_choice",
      "question": "Rond 3,47 af op één decimaal.",
      "context": null,
      "options": ["3,5", "3,4", "3,0", "4,0"],
      "correctAnswer": 0,
      "stimulusAids": [
        { "type": "numberline", "data": { "start": 3.4, "end": 3.5, "marked": [3.47], "step": 0.1, "label": "3,47 op de getallenlijn tussen 3,4 en 3,5" } }
      ],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Afronden op 1 decimaal", "content": "Kijk naar het honderdstencijfer (het tweede cijfer achter de komma). Is het 5 of hoger? Rond dan omhoog. Is het lager dan 5? Rond dan omlaag.", "icon": "lightbulb" } },
        { "type": "numberline", "showWhen": "wrong", "data": { "start": 3.4, "end": 3.5, "marked": [3.47], "highlight": [3.5], "step": 0.1, "label": "3,47 ligt dichter bij 3,5 dan bij 3,4" } }
      ],
      "conceptId": "komma_afronden_tienden",
      "variantIndex": 1,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.76,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "get.afronden-altijd-omlaag", "label": "Altijd naar beneden afgerond", "optionIndex": 1 },
          { "id": "get.afronden-aantal-decimalen-verkeerd", "label": "Op heel getal afgerond i.p.v. 1 decimaal", "optionIndex": 2 },
          { "id": "get.afronden-aantal-decimalen-verkeerd", "label": "Op eenhedenplek afgerond", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Kijk naar het honderdstencijfer in 3,47: dat is de 7. Is 7 gelijk aan of groter dan 5? Ja — dus je rondt omhoog af. 3,47 wordt 3,5. Controleer: 3,47 ligt dichter bij 3,5 dan bij 3,4.",
        "solutionSteps": ["Kijk naar het honderdstencijfer: de 7 in 3,47", "Is 7 gelijk aan of groter dan 5? Ja", "Rond omhoog af: 3,47 → 3,5", "Check: 3,47 ligt dichter bij 3,5 dan bij 3,4 ✓"],
        "distractorExplanations": {
          "0": "Goed! Het honderdstencijfer is 7 (≥ 5), dus 3,47 wordt 3,5.",
          "1": "Je dacht waarschijnlijk dat je altijd naar beneden afrondt. Maar het honderdstencijfer is 7, en 7 is groter dan 5. Onthoud: 5 of meer = omhoog afronden. Dus 3,47 → 3,5, niet 3,4.",
          "2": "Je dacht waarschijnlijk dat je op een heel getal moest afronden. Maar de vraag vraagt op één decimaal. Op 1 decimaal: 3,5. Op een heel getal zou het 3 zijn. Onthoud: lees goed hoeveel decimalen gevraagd worden.",
          "3": "Je dacht waarschijnlijk dat het honderdstencijfer (7) bij de eenheden hoort. Maar 3,47 afgerond op 1 decimaal is 3,5, niet 4,0. Onthoud: je rondt af op de tiendenplek, niet op de eenhedenplek."
        }
      }
    },
    {
      "id": "GET-KOMMA-AFRONDEN-002",
      "familyId": "GET-KOMMA-AFRONDEN",
      "module": "Getalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "komma_afronden",
      "questionType": "multiple_choice",
      "question": "Rond 12,345 af op twee decimalen.",
      "context": null,
      "options": ["12,35", "12,34", "12,3", "12,40"],
      "correctAnswer": 0,
      "stimulusAids": [
        { "type": "numberline", "data": { "start": 12.34, "end": 12.35, "marked": [12.345], "step": 0.01, "label": "12,345 op de getallenlijn" } }
      ],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Afronden op 2 decimalen", "content": "Kijk naar het duizendstencijfer (het derde cijfer achter de komma). Is het 5 of hoger? Rond dan omhoog. Is het lager dan 5? Rond dan omlaag.", "icon": "lightbulb" } }
      ],
      "conceptId": "komma_afronden_honderdsten",
      "variantIndex": 2,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.73,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "get.afronden-bij-5-omlaag", "label": "Bij 5 naar beneden afgerond", "optionIndex": 1 },
          { "id": "get.afronden-aantal-decimalen-verkeerd", "label": "Op 1 decimaal afgerond i.p.v. 2", "optionIndex": 2 },
          { "id": "get.afronden-onnodige-nul", "label": "Onnodige nul toegevoegd / overgeschoten", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Kijk naar het duizendstencijfer in 12,345: dat is de 5. Is 5 gelijk aan of groter dan 5? Ja — dus je rondt omhoog af. 12,345 wordt 12,35. Controleer: 12,35 heeft twee decimalen ✓.",
        "solutionSteps": ["Kijk naar het duizendstencijfer: de 5 in 12,345", "Is 5 gelijk aan of groter dan 5? Ja", "Rond omhoog af: 12,345 → 12,35"],
        "distractorExplanations": {
          "0": "Goed! Het duizendstencijfer is 5 (≥ 5), dus 12,345 wordt 12,35.",
          "1": "Je dacht waarschijnlijk dat je bij een 5 naar beneden afrondt. Maar de afspraak is: 5 of meer → altijd omhoog. Dus 12,35, niet 12,34. Onthoud: bij twijfel, bij 5 ga je omhoog.",
          "2": "Je dacht waarschijnlijk dat je op 1 decimaal moest afronden. Maar de vraag vraagt op 2 decimalen. Op 2 decimalen: 12,35. Op 1 decimaal zou het 12,3 zijn. Onthoud: tel het aantal gevraagde decimalen.",
          "3": "Je dacht waarschijnlijk dat je een nul moest toevoegen. Maar 12,35 is het antwoord — de extra nul in 12,40 verandert de waarde niet en is niet nodig. Onthoud: schrijf geen onnodige nullen achter het laatste cijfer."
        }
      }
    },
    {
      "id": "GET-KOMMA-AFRONDEN-003",
      "familyId": "GET-KOMMA-AFRONDEN",
      "module": "Getalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "komma_afronden",
      "questionType": "multiple_choice",
      "question": "Rond 9,95 af op één decimaal.",
      "context": null,
      "options": ["10,0", "9,9", "10", "9,10"],
      "correctAnswer": 0,
      "stimulusAids": [
        { "type": "numberline", "data": { "start": 9.9, "end": 10.0, "marked": [9.95], "step": 0.1, "label": "9,95 op de getallenlijn" } }
      ],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Doorrol bij afronden", "content": "Soms loopt het afronden door naar de volgende positie. Als 9,9 omhoog gaat, wordt het 10,0. De 9 op de tiendenplek loopt door naar de eenheden.", "icon": "lightbulb" } }
      ],
      "conceptId": "komma_afronden_doorrol",
      "variantIndex": 3,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.70,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "get.afronden-bij-5-omlaag", "label": "Bij 5 naar beneden afgerond", "optionIndex": 1 },
          { "id": "get.afronden-onnodige-nul", "label": "Decimaal weggelaten (10 i.p.v. 10,0)", "optionIndex": 2 },
          { "id": "get.afronden-doorrol-vergeten", "label": "Doorrol vergeten (9,10)", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Kijk naar het honderdstencijfer in 9,95: dat is de 5. Is 5 gelijk aan of groter dan 5? Ja — dus omhoog. 9,9 + 0,1 = 10,0. Let op: de 9 op de tiendenplek loopt door naar de eenheden! Controleer: 10,0 afgerond op 1 decimaal klopt — de decimaal staat er nog bij.",
        "solutionSteps": ["Kijk naar het honderdstencijfer: de 5 in 9,95", "Is 5 gelijk aan of groter dan 5? Ja", "Rond omhoog af: 9,9 + 0,1 = 10,0", "Let op: de 9 loopt door naar de eenheden!", "Check: schrijf 10,0 (met decimaal) omdat gevraagd is op 1 decimaal ✓"],
        "distractorExplanations": {
          "0": "Goed! 9,95 afgerond op 1 decimaal = 10,0. De 5 zorgt voor omhoog, en 9,9 + 0,1 = 10,0.",
          "1": "Je dacht waarschijnlijk dat je bij een 5 naar beneden afrondt. Maar het honderdstencijfer is 5, en 5 of meer = altijd omhoog. Dus 10,0, niet 9,9. Onthoud: bij 5 ga je omhoog.",
          "2": "Wiskundig zijn 10 en 10,0 hetzelfde. Maar bij afronden op 1 decimaal schrijf je 10,0. Zo laat je zien dat je op de tiendenplek hebt afgerond. Onthoud: schrijf het gevraagde aantal decimalen.",
          "3": "Je dacht waarschijnlijk dat je de 9 als 10 schrijft maar de tienden behoudt. Maar 9,95 → 10,0, niet 9,10. De hele 9,9 loopt door naar 10,0. Onthoud: als de tiendenplek doorloopt, verandert ook het getal vóór de komma."
        }
      }
    },
    {
      "id": "GET-KOMMA-AFRONDEN-004",
      "familyId": "GET-KOMMA-AFRONDEN",
      "module": "Getalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "komma_afronden",
      "questionType": "multiple_choice",
      "question": "Een product kost €7,849. Rond af op centen (twee decimalen).",
      "context": null,
      "options": ["€7,85", "€7,84", "€7,90", "€8,00"],
      "correctAnswer": 0,
      "stimulusAids": [
        { "type": "numberline", "data": { "start": 7.84, "end": 7.85, "marked": [7.849], "step": 0.01, "label": "€7,849 op de getallenlijn tussen €7,84 en €7,85" } }
      ],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Afronden op centen = afronden op 2 decimalen", "content": "Centen zijn honderdsten van een euro. Kijk naar het duizendstencijfer (het derde cijfer achter de komma). Is het 5 of hoger? Rond dan omhoog.", "icon": "lightbulb" } }
      ],
      "conceptId": "komma_afronden_context_geld",
      "variantIndex": 4,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "get.afronden-altijd-omlaag", "label": "Naar beneden afgerond", "optionIndex": 1 },
          { "id": "get.afronden-aantal-decimalen-verkeerd", "label": "Op 1 decimaal afgerond i.p.v. 2", "optionIndex": 2 },
          { "id": "get.afronden-aantal-decimalen-verkeerd", "label": "Op hele euro's afgerond i.p.v. centen", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Kijk naar het duizendstencijfer in 7,849: dat is de 9. Is 9 gelijk aan of groter dan 5? Ja — dus omhoog. €7,84 wordt €7,85. Controleer: €7,85 heeft twee decimalen (centen) ✓.",
        "solutionSteps": ["Kijk naar het duizendstencijfer: de 9 in 7,849", "Is 9 gelijk aan of groter dan 5? Ja", "Rond omhoog af: €7,849 → €7,85", "Check: twee decimalen = centen ✓"],
        "distractorExplanations": {
          "0": "Goed! Het duizendstencijfer is 9 (≥ 5), dus €7,849 ≈ €7,85.",
          "1": "Je dacht waarschijnlijk dat je naar beneden afrondt. Maar het duizendstencijfer is 9, en 9 is groter dan 5. Onthoud: 5 of meer = omhoog afronden. Dus €7,85, niet €7,84.",
          "2": "Je dacht waarschijnlijk dat je op 1 decimaal moest afronden. Maar centen zijn 2 decimalen. Op 2 decimalen: €7,85. Op 1 decimaal zou het €7,8 zijn (niet €7,90). Onthoud: centen = het tweede cijfer achter de komma.",
          "3": "Je dacht waarschijnlijk dat je op hele euro's moest afronden. Maar de vraag vraagt op centen (2 decimalen). Op centen: €7,85. Op hele euro's zou het €8,00 zijn. Onthoud: lees goed hoeveel decimalen gevraagd worden."
        }
      }
    },
    {
      "id": "GET-KOMMA-AFRONDEN-005",
      "familyId": "GET-KOMMA-AFRONDEN",
      "module": "Getalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "komma_afronden",
      "questionType": "multiple_choice",
      "question": "Rond 0,0451 af op twee decimalen.",
      "context": null,
      "options": ["0,05", "0,04", "0,045", "0,00"],
      "correctAnswer": 0,
      "stimulusAids": [
        { "type": "numberline", "data": { "start": 0.04, "end": 0.05, "marked": [0.0451], "step": 0.01, "label": "0,0451 op de getallenlijn tussen 0,04 en 0,05" } }
      ],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Afronden op 2 decimalen bij kleine getallen", "content": "Kijk naar het duizendstencijfer (het derde cijfer achter de komma). In 0,0451 is dat de 5. Is het 5 of hoger? Rond dan omhoog: 0,04 wordt 0,05.", "icon": "lightbulb" } }
      ],
      "conceptId": "komma_afronden_klein_getal",
      "variantIndex": 5,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.71,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "get.afronden-bij-5-omlaag", "label": "Bij 5 naar beneden afgerond", "optionIndex": 1 },
          { "id": "get.afronden-aantal-decimalen-verkeerd", "label": "Op 3 decimalen afgerond i.p.v. 2", "optionIndex": 2 },
          { "id": "get.afronden-volgend-cijfer-meerekenen", "label": "Te klein getal als 0 aangenomen", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Kijk naar het duizendstencijfer in 0,0451: dat is de 5. Is 5 gelijk aan of groter dan 5? Ja — dus omhoog. 0,04 wordt 0,05. Controleer: 0,05 heeft twee decimalen ✓.",
        "solutionSteps": ["Kijk naar het duizendstencijfer: de 5 in 0,0451", "Is 5 gelijk aan of groter dan 5? Ja", "Rond omhoog af: 0,0451 → 0,05", "Check: 0,05 heeft twee decimalen ✓"],
        "distractorExplanations": {
          "0": "Goed! Het duizendstencijfer is 5 (≥ 5), dus 0,0451 ≈ 0,05.",
          "1": "Je dacht waarschijnlijk dat je bij een 5 naar beneden afrondt. Maar de afspraak is: 5 of meer → altijd omhoog. Dus 0,05, niet 0,04. Onthoud: bij twijfel, bij 5 ga je omhoog.",
          "2": "Je dacht waarschijnlijk dat je op 3 decimalen moest afronden. Maar de vraag vraagt op 2 decimalen. Op 2 decimalen: 0,05. Op 3 decimalen zou het 0,045 zijn. Onthoud: tel het aantal gevraagde decimalen.",
          "3": "Je dacht waarschijnlijk dat 0,0451 zo klein is dat het nul wordt. Maar 0,0451 is klein maar niet nul. Afgerond op 2 decimalen: 0,05. Onthoud: kijk altijd naar het derde cijfer achter de komma, ook bij kleine getallen."
        }
      }
    },
    {
      "id": "GET-KOMMA-AFRONDEN-006",
      "familyId": "GET-KOMMA-AFRONDEN",
      "module": "Getalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "komma_afronden",
      "questionType": "fill_in",
      "question": "Rond 6,83 af op één decimaal. Typ je antwoord met een komma (bijv. 6,8).",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": { "acceptedAnswers": ["6,8", "6.8"], "caseSensitive": false, "placeholder": "?,?" },
      "stimulusAids": [
        { "type": "numberline", "data": { "start": 6.8, "end": 6.9, "marked": [6.83], "step": 0.1, "label": "6,83 op de getallenlijn tussen 6,8 en 6,9" } }
      ],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Afronden op 1 decimaal", "content": "Kijk naar het honderdstencijfer (het tweede cijfer achter de komma). Is het 5 of hoger? Rond dan omhoog. Is het lager dan 5? Rond dan omlaag.", "icon": "lightbulb" } }
      ],
      "conceptId": "komma_afronden_tienden_fill",
      "variantIndex": 6,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "get.afronden-volgend-cijfer-meerekenen", "label": "Verkeerd vervolgcijfer bekeken" }
        ]
      },
      "feedback": {
        "explanationText": "Kijk naar het honderdstencijfer in 6,83: dat is de 3. Is 3 kleiner dan 5? Ja — dus je rondt omlaag af. 6,83 wordt 6,8. Onthoud: bij afronden op 1 decimaal kijk je altijd naar het tweede cijfer achter de komma. De 3 is kleiner dan 5, dus de tienden blijven hetzelfde.",
        "solutionSteps": ["Kijk naar het honderdstencijfer: de 3 in 6,83", "Is 3 kleiner dan 5? Ja", "Rond omlaag af: 6,83 → 6,8", "Check: de tienden (8) blijven hetzelfde ✓"]
      }
    },
    {
      "id": "GET-KOMMA-AFRONDEN-007",
      "familyId": "GET-KOMMA-AFRONDEN",
      "module": "Getalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "komma_afronden",
      "questionType": "fill_in",
      "question": "Rond 15,678 af op twee decimalen. Typ je antwoord met een komma (bijv. 15,68).",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": { "acceptedAnswers": ["15,68", "15.68"], "caseSensitive": false, "placeholder": "?,??" },
      "stimulusAids": [
        { "type": "numberline", "data": { "start": 15.67, "end": 15.68, "marked": [15.678], "step": 0.01, "label": "15,678 op de getallenlijn tussen 15,67 en 15,68" } }
      ],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Afronden op 2 decimalen", "content": "Kijk naar het duizendstencijfer (het derde cijfer achter de komma). Is het 5 of hoger? Rond dan omhoog. Is het lager dan 5? Rond dan omlaag.", "icon": "lightbulb" } }
      ],
      "conceptId": "komma_afronden_honderdsten_fill",
      "variantIndex": 7,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.72,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "get.afronden-altijd-omlaag", "label": "Verkeerde richting bij ≥ 5" }
        ]
      },
      "feedback": {
        "explanationText": "Kijk naar het duizendstencijfer in 15,678: dat is de 8. Is 8 gelijk aan of groter dan 5? Ja — dus omhoog. 15,67 wordt 15,68. Onthoud: bij afronden op 2 decimalen kijk je naar het derde cijfer achter de komma. De 8 is groter dan 5, dus de honderdsten gaan 1 omhoog.",
        "solutionSteps": ["Kijk naar het duizendstencijfer: de 8 in 15,678", "Is 8 gelijk aan of groter dan 5? Ja", "Rond omhoog af: 15,678 → 15,68", "Check: de honderdsten gaan van 7 naar 8 ✓"]
      }
    },
    {
      "id": "GET-KOMMA-AFRONDEN-008",
      "familyId": "GET-KOMMA-AFRONDEN",
      "module": "Getalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "komma_afronden",
      "questionType": "fill_in",
      "question": "Een fles bevat 2,749 liter. Rond af op één decimaal. Typ je antwoord met een komma (bijv. 2,7).",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": { "acceptedAnswers": ["2,7", "2.7"], "caseSensitive": false, "placeholder": "?,?" },
      "stimulusAids": [
        { "type": "numberline", "data": { "start": 2.7, "end": 2.8, "marked": [2.749], "step": 0.1, "label": "2,749 op de getallenlijn tussen 2,7 en 2,8" } }
      ],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Afronden op 1 decimaal", "content": "Kijk naar het honderdstencijfer (het tweede cijfer achter de komma). In 2,749 is dat de 4. Is 4 kleiner dan 5? Ja — dus je rondt omlaag af.", "icon": "lightbulb" } }
      ],
      "conceptId": "komma_afronden_context_liter_fill",
      "variantIndex": 8,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.73,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "get.afronden-volgend-cijfer-meerekenen", "label": "Naar duizendsten gekeken i.p.v. honderdsten" }
        ]
      },
      "feedback": {
        "explanationText": "Kijk naar het honderdstencijfer in 2,749: dat is de 4. Is 4 kleiner dan 5? Ja — dus omlaag. 2,749 wordt 2,7. Pas op: kijk naar de 4, niet naar de 9! De 9 is het duizendstencijfer. Bij afronden op 1 decimaal telt alleen het honderdstencijfer.",
        "solutionSteps": ["Welk cijfer bepaalt? Het honderdstencijfer (2e achter de komma)", "In 2,749 is dat de 4", "Is 4 kleiner dan 5? Ja → rond omlaag af", "2,749 → 2,7", "Pas op: de 9 (duizendstencijfer) doet er niet toe bij 1 decimaal!"]
      }
    },
    {
      "id": "GET-KOMMA-AFRONDEN-009",
      "familyId": "GET-KOMMA-AFRONDEN",
      "module": "Getalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "komma_afronden",
      "questionType": "multiple_choice",
      "question": "Een wetenschapper meet een stof en vindt 0,04962 gram. Eerst rondt ze af op drie decimalen, daarna rondt ze dat resultaat af op twee decimalen. Wat is het eindresultaat?",
      "context": null,
      "options": ["0,05", "0,04", "0,050", "0,06"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Stapsgewijs afronden", "content": "Bij stapsgewijs afronden voer je elke stap apart uit. Eerst op 3 decimalen, dan dat resultaat op 2 decimalen. Rond niet in één keer af — dat kan een ander antwoord geven!", "icon": "lightbulb" } }
      ],
      "conceptId": "komma_afronden_stapsgewijs",
      "variantIndex": 9,
      "citoDifficulty": 0.58,
      "citoDiscrimination": 0.68,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "get.afronden-eenmalig-vs-stapsgewijs", "label": "Direct op 2 decimalen afgerond", "optionIndex": 1 },
          { "id": "get.afronden-tussenresultaat-als-eind", "label": "Tussenresultaat (0,050) als eindantwoord", "optionIndex": 2 },
          { "id": "get.afronden-doorrol-vergeten", "label": "Doorrol verkeerd toegepast", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Dit is een tweestapsprobleem. Stap 1: rond 0,04962 af op 3 decimalen. Kijk naar het vierde cijfer achter de komma: dat is de 6. Is 6 ≥ 5? Ja → 0,04962 wordt 0,050. Stap 2: rond 0,050 af op 2 decimalen. Kijk naar het derde cijfer: dat is de 0. Is 0 < 5? Ja → 0,050 wordt 0,05. Dus het eindresultaat is 0,05.",
        "solutionSteps": ["Stap 1: rond 0,04962 af op 3 decimalen", "Kijk naar het 4e cijfer achter de komma: de 6", "Is 6 ≥ 5? Ja → 0,04962 → 0,050", "Stap 2: rond 0,050 af op 2 decimalen", "Kijk naar het 3e cijfer achter de komma: de 0", "Is 0 < 5? Ja → 0,050 → 0,05", "Eindresultaat: 0,05"],
        "distractorExplanations": {
          "0": "Goed! Eerst op 3 decimalen: 0,04962 → 0,050. Dan op 2 decimalen: 0,050 → 0,05.",
          "1": "Je dacht waarschijnlijk dat je in één keer op 2 decimalen afrondt. Maar de vraag zegt: eerst op 3, dan op 2. Als je direct op 2 afrondt: het duizendstencijfer is 9, dus 0,04962 → 0,05. Toevallig hetzelfde! Maar bij andere getallen kan stapsgewijs een ander antwoord geven. Onthoud: volg altijd de gevraagde stappen.",
          "2": "Je dacht waarschijnlijk dat 0,050 het eindantwoord is. Maar 0,050 is het resultaat na stap 1 (3 decimalen). Je moet nog een stap: 0,050 → 0,05 (2 decimalen). Onthoud: voer beide stappen uit. 0,050 en 0,05 zijn wiskundig gelijk, maar bij de notatie schrijf je 0,05.",
          "3": "Je dacht waarschijnlijk dat de 9 in 0,04962 doorloopt naar de honderdsten. Maar bij stapsgewijs afronden kijk je per stap alleen naar het eerstvolgende cijfer. Stap 1: de 6 rondt de 9 omhoog → 0,050. Stap 2: de 0 verandert niets → 0,05. Onthoud: rond per stap af, niet alles tegelijk."
        }
      }
    },
    {
      "id": "GET-KOMMA-AFRONDEN-010",
      "familyId": "GET-KOMMA-AFRONDEN",
      "module": "Getalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "komma_afronden",
      "questionType": "multiple_choice",
      "question": "Twee leerlingen meten de lengte van een tafel. Leerling A meet 1,847 m en rondt af op 1 decimaal. Leerling B meet 1,853 m en rondt ook af op 1 decimaal. Vergelijk hun afgeronde resultaten: zijn ze gelijk of verschillend?",
      "context": null,
      "options": [
        "Verschillend: A vindt 1,8 m en B vindt 1,9 m",
        "Gelijk: allebei 1,8 m",
        "Gelijk: allebei 1,9 m",
        "Verschillend: A vindt 1,9 m en B vindt 1,8 m"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        { "type": "numberline", "data": { "start": 1.8, "end": 1.9, "marked": [1.847, 1.853], "step": 0.1, "label": "1,847 en 1,853 op de getallenlijn — aan welke kant van 1,85 liggen ze?" } }
      ],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Elk getal apart afronden", "content": "Rond elk getal apart af. Kijk per getal naar het honderdstencijfer. 1,847: honderdstencijfer = 4 (< 5 → omlaag). 1,853: honderdstencijfer = 5 (≥ 5 → omhoog).", "icon": "lightbulb" } }
      ],
      "conceptId": "komma_afronden_vergelijken",
      "variantIndex": 10,
      "citoDifficulty": 0.55,
      "citoDiscrimination": 0.72,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "get.afronden-altijd-omlaag", "label": "Beide naar beneden afgerond", "optionIndex": 1 },
          { "id": "get.afronden-bij-5-omlaag", "label": "Beide naar boven afgerond, ook 1,847", "optionIndex": 2 },
          { "id": "get.afronden-volgend-cijfer-meerekenen", "label": "Resultaten verwisseld", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Rond elk getal apart af op 1 decimaal. Leerling A: 1,847 → kijk naar het honderdstencijfer: de 4. Is 4 < 5? Ja → 1,847 wordt 1,8. Leerling B: 1,853 → kijk naar het honderdstencijfer: de 5. Is 5 ≥ 5? Ja → 1,853 wordt 1,9. Dus A vindt 1,8 m en B vindt 1,9 m — ze zijn verschillend! Hoewel de metingen maar 0,006 m verschilen, vallen ze aan verschillende kanten van de afrondgrens 1,85.",
        "solutionSteps": ["Leerling A: 1,847 → honderdstencijfer = 4", "Is 4 < 5? Ja → 1,847 → 1,8", "Leerling B: 1,853 → honderdstencijfer = 5", "Is 5 ≥ 5? Ja → 1,853 → 1,9", "Vergelijk: 1,8 ≠ 1,9 → verschillend", "Inzicht: ze liggen aan weerszijden van de grens 1,85"],
        "distractorExplanations": {
          "0": "Goed! A: 1,847 → 1,8 (honderdstencijfer 4 < 5). B: 1,853 → 1,9 (honderdstencijfer 5 ≥ 5). Verschillend!",
          "1": "Je dacht waarschijnlijk dat beide getallen naar beneden afronden. Maar 1,853 heeft honderdstencijfer 5, en 5 ≥ 5 → omhoog. Dus B vindt 1,9, niet 1,8. Onthoud: rond elk getal apart af en kijk per getal naar het honderdstencijfer.",
          "2": "Je dacht waarschijnlijk dat beide getallen omhoog afronden. Maar 1,847 heeft honderdstencijfer 4, en 4 < 5 → omlaag. Dus A vindt 1,8, niet 1,9. Onthoud: alleen bij 5 of meer ga je omhoog.",
          "3": "Je hebt de resultaten omgedraaid. A meet 1,847 → 1,8 (omlaag) en B meet 1,853 → 1,9 (omhoog). Niet andersom! Onthoud: kijk per leerling naar het honderdstencijfer van hun eigen meting."
        }
      }
    }
  ]
}